import { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import './Hero.css';

function HeroVideo() {
  const videoRef = useRef(null);
  const [ended, setEnded] = useState(false);

  const handleEnded = () => {
    setEnded(true);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
      setEnded(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.08, ease: 'easeOut' }}
      className="heroVideo"
    >
      <video
        ref={videoRef}
        src="/videos/keraunos-ai-hero.mp4"
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={handleEnded}
        aria-label="Keraunos AI glass thunderbolt concentric circles animation"
      />
      {ended && (
        <button
          className="heroReplayButton"
          onClick={handleReplay}
          aria-label="Replay Keraunos AI video"
        >
          <Play size={16} />
          Replay
        </button>
      )}
    </motion.div>
  );
}

export default function Hero() {
  return (
    <section className="heroContainer">
      <div className="heroOverlay">
        <HeroVideo />

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: 'easeOut' }}
          className="heroTitle"
        >
          DETERMINISTIC AI
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15, ease: 'easeOut' }}
          className="heroLead"
        >
          Built on the Stripe Minions Blueprint pattern that safeguards code supporting over
          $1 trillion in annual payment volume. Keraunos wraps the LLM model in
          code-enforced quality gates the AI cannot skip, override, or silently
          ignore.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2, ease: 'easeOut' }}
          className="heroSubtitle"
        >
          Keraunos is a deterministic, blueprint-first AI agent system. It ships
          provably correct output, or escalates to a human — on secure infrastructure
          you control.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3, ease: 'easeOut' }}
          className="heroButtons"
        >
          <a href="mailto:office@keraunos-ai.com" className="btnPrimary">Contact</a>
        </motion.div>
      </div>
    </section>
  );
}
